import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Icon } from '@hvcgroep/design-system';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import routes from '../../config/routes';
import getEntries from '../../helpers/getEntries';
import { ReactComponent as LogoFull } from '../../assets/images/logo-full.svg';
import { ReactComponent as LogoTruncated } from '../../assets/images/logo-truncated.svg';

import './style.scss';

interface Props {
}

const Navbar: React.FC<Props> = () => {
  const location = useLocation();

  const [isMenuOpen, setMenuOpen] = React.useState(false);

  const { t } = useTranslation();

  const menuItems = {
    overview: routes.overview,
    usage: routes.usage,
    invoices: routes.invoices,
    myDetails: routes.myDetails,
  };

  function toggleMenu() {
    setMenuOpen(!isMenuOpen);
  }

  const classes = c('navbar', 'mo-navbar', {
    'mo-navbar--is-open': isMenuOpen,
  });

  const MOBILE_MENU_ID = 'mo-mobile-menu';

  return (
    <>
      <nav className={classes}>
        <Container fluid>
          <div className="region-navigation">
            <section id="block-hvcgroep-theme-branding" data-block-plugin-id="system_branding_block">
              <div className="block-wrapper">
                <div className="block-content-wrapper">
                  <Link to="/" className="site-logo mo-navbar__logo-wrapper">
                    <span className="sr-only">
                      {t('navbar.logo')}
                    </span>
                    <LogoFull className="mo-navbar__logo mo-navbar__logo--full" />
                    <LogoTruncated className="mo-navbar__logo mo-navbar__logo--truncated" />
                  </Link>
                </div>
              </div>
            </section>
            <nav className="block block-menu navigation menu--main">
              <ul className="menu">
                {getEntries(menuItems).map(([pageKey, pageConfig]) => {
                  return (
                    <li className="menu-item" key={`navbar-menu-item-${pageKey}`}>
                      <Link
                        to={pageConfig.path}
                        className={location.pathname === pageConfig.path ? 'is-active' : ''}
                      >
                        {t(`navbar.${pageKey}`)}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
            <div className="block block-menu navigation menu--secondary mo-menu--secondary">
              <button
                className="mo-navbar__menu-button"
                type="button"
                onClick={toggleMenu}
                aria-expanded={isMenuOpen}
                aria-controls={MOBILE_MENU_ID}
              >
                {t(isMenuOpen ? 'navbar.close' : 'navbar.open')}
                <Icon
                  icon={isMenuOpen ? 'close' : 'menu'}
                  className="mo-menu-icon"
                />
              </button>
              <ul className="menu">
                <li className="menu-item mo-menu-item--desktop-only">
                  <Link to={routes.contact.path}>
                    {t('navbar.contact')}
                    <Icon
                      icon="live_help"
                      className="mo-menu-icon"
                    />
                  </Link>
                </li>
                <li className="menu-item mo-menu-item--desktop-only">
                  <Link to={routes.LoggingOutPage.path}>
                    {t('navbar.logout')}
                    <Icon
                      icon="logout"
                      className="mo-menu-icon"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Container>
        {isMenuOpen && (
          <div className="mo-navbar__mobile-menu-wrapper" id={MOBILE_MENU_ID}>
            <Container fluid>
              <ul className="mo-navbar__mobile-menu">
                {getEntries(menuItems).map(([pageKey, pageConfig]) => {
                  return (
                    <li className="menu-item" key={`navbar-mobile-menu-item-${pageKey}`}>
                      <Link className="h4" to={pageConfig.path}>
                        {t(`navbar.${pageKey}`)}
                      </Link>
                      <Icon icon="arrow_forward_400" variant="1" />
                    </li>
                  );
                })}
              </ul>
              <ul className="mo-navbar__mobile-secondary-menu">
                <li className="menu-item">
                  <Link to={routes.contact.path}>
                    {t('navbar.contact')}
                    <Icon
                      icon="live_help"
                      className="mo-menu-icon"
                    />
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to={routes.LoggingOutPage.path}>
                    {t('navbar.logout')}
                    <Icon
                      icon="logout"
                      className="mo-menu-icon"
                    />
                  </Link>
                </li>
              </ul>
            </Container>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
